import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters(['clientName']),
    isAdmin () {
      return this.userData && parseInt(this.userData.userlevel) >= 7
    },
    isSuperAdmin () {
      return this.userData && parseInt(this.userData.userlevel) >= 10
    },
    isBasicUser () {
      return this.userData && parseInt(this.userData.userlevel) >= 3
    },
    canAccessSettings () {
      return this.isAdmin
    },
    canAccessJohkuAccount () {
      return this.isAdmin
    },
    canSetEditMode () {
      return this.isAdmin && this.clientName
    },
    canModifyLayouts () {
      return this.isAdmin && this.clientName
    },
    canModifyComponents () {
      return this.isAdmin && this.clientName
    },
    showEditComponentButton () {
      return this.editMode && this.canModifyComponents
    },
    showAddComponentButton () {
      return this.showEditComponentButton && !this.isInSettingsMenu
    },
    showEditLayoutButton () {
      return this.editMode && this.canModifyLayouts
    },
    showAddLayoutButton () {
      return this.showEditLayoutButton
    },
    isInSettingsMenu () {
      return this.components && this.components.some(c => c.id === 'settingsmenu')
    }
  },
  methods: {
    isComponentEditable (component) {
      if (!component || component.type === 'EmptyColumn') {
        return false
      }
      return true
    }
  }
}